@if (auth.isRecipient) {
  <h2 class="heading" i18n="@@marketplace.searchMask.recipientTitle">Assistenten finden</h2>
}
@if (auth.isGiver) {
  <h2 class="heading" i18n="@@marketplace.searchMask.giverTitle">Assistenznehmer finden</h2>
}

<div>
  <div class="form-group">
    <label class="label" for="search-location" i18n="@@marketplace.searchMask.formPlaceOfUse">Einsatzort</label>

    <ng-select #locationSelect
      (keydown.delete)="clearLocation()"
      [formControl]="locationControl"
      [items]="locations$ | async"
      [typeahead]="locationInput$"
      bindLabel="zipAndName"
      class="typeahead"
      i18n-placeholder="@@marketplace.searchMask.formPlaceholderChose"
      i18n-typeToSearchText="@@shared.giverOffer.placeholder.plzTypeToSearchText"
      labelForId="search-location"
      notFoundText="Keine Treffer"
      placeholder="Auswählen..."
      typeToSearchText="PLZ/Ortsnamen eingeben">
    </ng-select>
    @if (locationControl.invalid && (locationControl.touched || locationControl.dirty)) {
      <div
        class="validation error">Bitte wählen Sie den Einsatzort aus.
      </div>
    }
  </div>

  <div class="form-group">
    <label class="label" for="search-services" i18n="@@marketplace.searchMask.formAssistance"
    id="search-services-label">Assistenz</label>
    <ng-select [clearable]="false"
      [formControl]="addService"
      [items]="selectableServices"
      [searchable]="false"
      appAddIconChevronDown
      aria-controls="selected-services"
      bindLabel="name"
      i18n-placeholder="@@marketplace.searchMask.formPlaceholderChose"
      labelForId="search-services"
      placeholder="Auswählen...">
    </ng-select>

    <ul aria-labelledby="search-services-label" aria-live="polite" class="tag-list vertical" id="selected-services"
      role="group">
      @for (service of selectedServices; track service) {
        <li>
          <button (click)="unselectService(service)"
            [attr.aria-label]="service.name + ' entfernen'"
            aria-controls="selected-services"
            class="tag-button"
            role="button">
            <app-tag status="Added">{{ service.name }}</app-tag>
          </button>
        </li>
      }
    </ul>

  </div>
</div>

<button (click)="openAdvancedSearch()" class="button block" i18n="@@marketplace.searchMask.btnOpenAdvancedSearch">Filter
    anzeigen
</button>

@if (auth.isRecipient) {
  <div class="save-query-section">
    @if (unsavedQuery) {
      <p i18n="@@marketplace.searchMask.recipientFormUnsavedQuery">Sie haben die Suche geändert.
        Speichern Sie die Suche in Ihrem Profil, um beim nächsten Besuch dieselbe Suche direkt verfügbar zu haben.</p>
    }
    @if (!unsavedQuery) {
      <p i18n="@@marketplace.searchMask.recipientFormNoUnsavedQuery">Sie haben die Suche in Ihrem
        Profil gespeichert.</p>
    }
    <button (click)="save()" [disabled]="!unsavedQuery || isSaving" class="button block"
      i18n="@@marketplace.searchMask.recipientFormBtnSave">Diese Suche speichern
    </button>
  </div>
}
@if (auth.isGiver) {
  <div class="save-query-section">
    @if (unsavedQuery) {
      <p i18n="@@marketplace.searchMask.giverFormUnsavedQuery">Sie haben neue Leistungen gesucht.
        Möchten Sie Ihr Profil entsprechend aktualisieren um mit diesen Leistungen gefunden zu werden?</p>
    }
    @if (!unsavedQuery) {
      <p i18n="@@marketplace.searchMask.giverFormNoUnsavedQuery">Sie haben die Leistungen in Ihrem
        Profil gespeichert.</p>
    }
    <button (click)="save()" [disabled]="!unsavedQuery || isSaving" class="button block"
      i18n="@@marketplace.searchMask.giverFormBtnSave">Leistungen aktualisieren
    </button>
  </div>
}
